import buttonError from "../assets/images/Button_Error.png";
import "./ErrorSuccessBox.css";

const ErrorSuccessBox = ({
  success,
  message,
}: {
  success: boolean;
  message: string;
}) => {
  return (
    <div
      id="errorSuccessBoxContainer"
      className={success ? "boxSuccess" : "boxFail"}
    >
      {!success && (
        <img alt={"error"} width="44px" height="44px" src={buttonError} />
      )}
      <p style={{ marginLeft: success ? "11px" : "" }}>{message}</p>
    </div>
  );
};

export default ErrorSuccessBox;
